import { render, staticRenderFns } from "./BiOfficeSelect.vue?vue&type=template&id=177ca3b2&"
import script from "./BiOfficeSelect.vue?vue&type=script&lang=ts&"
export * from "./BiOfficeSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports